import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import CardObject from "../../../components/global/CardObject";
import CardProject from "../../../components/global/CardProject";
import "./Index.css"
import CardName from "../../../components/global/CardName";
import ParameterModalRemove from "./ParameterModalRemove";
import ParameterModalArchive from "./ParameterModalArchive";
import ParameterModalArchiveCancel from "./ParameterModalArchiveCancel";
import ParameterIcon from "../../../components/card/widget/parameter/ParameterIcon";
import axios from "axios";
import ButtonAction from "../../../components/global/ButtonAction";
import CardDescription from "../../../components/card/CardDescription";
import ReferenceBlockItem from "./ReferenceBlockItem";
import immutabilityUpdate from 'immutability-helper'
import SrvButtonLink from "../../../components/global/SrvButtonLink";
import SrvButton from "../../../components/global/SrvButton";
import ReferenceModalRemove from "./ReferenceModalRemove";
import ReferenceModalArchiveCancel from "./ReferenceModalArchiveCancel";
import ErrorAdd from "../../../util/ErrorAdd";


function ParameterModalUpdate({ show, onHide, model }) {

    const stateParameter = useSelector((state) => state.parameterList);
    const stateSize = useSelector((state) => state.size);//Размеры окна

    const refHeader = useRef(null);//Шапка карточки
    const refFooter = useRef(null);//Footer карточки
    const [heightBody, setHeightBody] = useState(0);

    useEffect(() => {
        if (stateSize.desktop !== true) {
            setHeightBody(stateSize.windowHeight - refHeader.current.offsetHeight - refFooter.current.offsetHeight - 70);
        }

    }, [stateSize]);

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(null);

    const [modalRemoveShow, setModalRemoveShow] = useState(false);
    const [modalArchiveShow, setModalArchiveShow] = useState(false);
    const [modalArchiveCancelShow, setModalArchiveCancelShow] = useState(false);
    const [formObject, setFormObject] = useState([]);
    const [formProject, setFormProject] = useState([]);
    //const [referenceList, setReferenceList] = useState([]);
    //const [referenceDataList, setReferenceDataList] = useState([]);//status: 0-Загружено из БД; 1-Новая запись; 2-Обновить; 3-Удалить

    useEffect(() => {
        setFormObject(stateParameter.listObject.filter(a => a.ID_Parameter === model.ID).map((item) => { return item.ID_Object }));
        setFormProject(stateParameter.listProject.filter(a => a.ID_Parameter === model.ID).map((item) => { return item.ID_Project }));

        //Если справочник, то подгружаем элементы справочника
        if (model.ID_Type === 4) {
            loadReferenceList()
        }

    }, [stateParameter.list, model]);

    const [hideName, setHideName] = useState(false);
    const [logName, setLogName] = useState(null);
    const [loadingName, setLoadingName] = useState(false);

    function updateName(name) {
        setLoadingName(true);
        setLogName(null);

        if (name === null) {
            setLogName('Введите название параметра');
            setLoadingName(false);
        }
        else {
            axios.post('/api_tracker/parameter/updateName', { ID_Parameter: model.ID, Name: name })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoadingName(false);
                        setHideName(true);
                    }
                    else {
                        setLogName(res.data.Error);
                        setLoadingName(false);
                    }
                })
                .catch((err) => {
                    setLogName('Неизвестная ошибка!');
                    setLoadingName(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    const [hideDescription, setHideDescription] = useState(false);
    const [logDescription, setLogDescription] = useState(null);
    const [loadingDescription, setLoadingDescription] = useState(false);
    function updateDescription(val) {
        setLoadingDescription(true);
        setLogDescription(null);

        axios.post('/api_tracker/parameter/updateDescription', { ID_Parameter: model.ID, Description: val })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoadingDescription(false);
                    setHideDescription(true);
                }
                else {
                    setLogDescription(res.data.Error);
                    setLoadingDescription(false);
                }
            })
            .catch((err) => {
                setLogDescription('Неизвестная ошибка!');
                setLoadingDescription(false);
                ErrorAdd(err, window.location.href);
            });

    }
    function updateAllObject(val) {
        setLoading(true);

        axios.post('/api_tracker/parameter/updateAllObject', { ID_Parameter: model.ID, All_Object: val })
            .then((res) => {
                if (res.data.Status === 1) {
                    if (val === true) {
                        setFormObject([]);
                    }
                    setLoading(false);
                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });

    }
    function updateAllProject(val) {
        setLoading(true);

        axios.post('/api_tracker/parameter/updateAllProject', { ID_Parameter: model.ID, All_Project: val })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoading(false);
                    if (val === true) {
                        setFormProject([]);
                    }
                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });

    }

    //Изменение объекта
    function objectHundler(checked, id) {
        if (checked == true) {
            axios.post('/api_tracker/parameter/objectAdd', { ID_Parameter: model.ID, ID_Object: id })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoading(false);
                        setFormObject([...formObject.filter(a => a !== id), id]);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        else {
            axios.post('/api_tracker/parameter/objectRemove', { ID_Parameter: model.ID, ID_Object: id })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoading(false);
                        setFormObject([...formObject.filter(a => a !== id)]);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }
    //Изменение проекта
    function projectHandler(id, val) {

        if (val === true) {
            axios.post('/api_tracker/parameter/projectAdd', { ID_Parameter: model.ID, ID_Project: id })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoading(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        else {
            axios.post('/api_tracker/parameter/projectRemove', { ID_Parameter: model.ID, ID_Project: id })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoading(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    /***************************START ЭЛЕМЕНТЫ СПРАВОЧНИКА************************/
    const [tabReference, setTabReference] = useState(1);
    const [logReference, setLogReference] = useState(null);
    const [loadingReferenceAdd, setLoadingReferenceAdd] = useState(false);
    const [loadingReferenceUpdate, setLoadingReferenceUpdate] = useState(false);
    const [loadingReference, setLoadingReference] = useState(false);
    const [dataReference, setDataReference] = useState([]);
    const [dataReferenceArchive, setDataReferenceArchive] = useState([]);
    const [showSaveReference, setShowSaveReference] = useState(false);
    const [modalRemoveReference, setModalRemoveReference] = useState(false);
    const [modalArchiveCancelReference, setModalArchiveCancelReference] = useState(false);
    const [idReferenceSelected, setIdReferenceSelected] = useState(null);

    //Загрузит список элементов справочника
    function loadReferenceList() {
        setLoadingReference(true);
        axios.get('/api_tracker/parameter/ReferenceList', { params: { ID_Parameter: model.ID } })
            .then((res) => {
                if (res.data.Status === 1) {
                    //setReferenceList(res.data.Data);

                    setDataReference(prev => [])
                    const data_ = res.data.Data.filter(a => a.Archive === false).sort((a, b) => a.Order - b.Order).map((item, index) => {
                        return { id: item.ID, name: item.Value, order: index, num: index, status: 0, archive: item.Archive }
                    })


                    if (data_.length === 0) {
                        setDataReference(prev => [{ id: null, name: null, order: 0, num: 0, archive: false }]);
                    }
                    else {
                        setDataReference(prev => data_.sort((a, b) => a.order - b.order));
                    }

                    const data_archive = res.data.Data.filter(a => a.Archive === true).sort((a, b) => a.Order - b.Order).map((item, index) => {
                        return { id: item.ID, name: item.Value, order: index, num: index, status: 0, archive: item.Archive }
                    })
                    setDataReferenceArchive(data_archive);

                    setLoadingReference(false);
                }
                else {
                    setLogReference(res.data.Error);
                    setLoadingReference(false);
                }
            })
            .catch((err) => {
                setLogReference('Неизвестная ошибка!');
                setLoadingReference(false);
                ErrorAdd(err, window.location.href);
            });
    }

    function updateReference() {
        //setLoadingReference(true);
        setLoadingReferenceAdd(true);
        setLoadingReferenceUpdate(true);

        setLogReference(null)

        //Новые
        if (dataReference.filter(a => a.status === 1).length > 0) {
            const data_add = dataReference.filter(a => a.status === 1 & a.name !== null).map(item => {
                return { Value: item.name, Order: item.order }
            })
            axios.post('/api_tracker/parameter/referenceAdd', { ID_Parameter: model.ID, Data: data_add })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoadingReferenceAdd(false);
                    }
                    else {
                        setLogReference(res.data.Error);
                        setLoadingReferenceAdd(false);
                    }
                })
                .catch((err) => {
                    setLogReference('Неизвестная ошибка!');
                    setLoadingReferenceAdd(false);
                });
        }
        else {
            setLoadingReferenceAdd(false);
        }
        //Измененные
        if (dataReference.filter(a => a.status === 2).length > 0) {
            const data_update = dataReference.filter(a => a.status === 2).map(item => {
                return { ID: item.id, Value: item.name, Order: item.order }
            })
            axios.post('/api_tracker/parameter/referenceUpdate', { ID_Parameter: model.ID, Data: data_update })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoadingReferenceUpdate(false);
                    }
                    else {
                        setLogReference(res.data.Error);
                        setLoadingReferenceUpdate(false);
                    }
                })
                .catch((err) => {
                    setLogReference('Неизвестная ошибка!');
                    setLoadingReferenceUpdate(false);
                });
        }
        else {
            setLoadingReferenceUpdate(false);
        }
    }

    useEffect(() => {
        if (loadingReferenceAdd === false & loadingReferenceUpdate === false) {
            //Если справочник, то подгружаем элементы справочника
            if (model.ID_Type === 4) {
                loadReferenceList()
            }
        }
        else {
            setLoadingReference(true);
        }

    }, [loadingReferenceAdd, loadingReferenceUpdate]);

    useEffect(() => {
        if (dataReference.filter(a => a.status !== 0).length > 0) {
            setShowSaveReference(true);
        }
        else {
            setShowSaveReference(false);
        }
    }, [dataReference]);

    //Добавит элемент справочника
    function addReference() {
        let order = dataReference.sort((a, b) => b.order - a.order)[0].order + 1;
        let num = dataReference.sort((a, b) => b.num - a.num)[0].num + 1;
        setDataReference([...dataReference.sort((a, b) => a.order - b.order), { id: null, name: null, order: order, status: 1, num: num, archive: false }]);
    }
    //Удалить элемент справочника
    function removeReference(num) {

        const id = dataReference.filter(a => a.num === num)[0].id;

        //Если только что созданная запись
        if (id === null) {

            setDataReference(dataReference.filter(a => a.num !== num));
        }
        else {
            setIdReferenceSelected(id);
            setModalRemoveReference(true);
        }
    }
    function archiveCancelReference(num) {
        const id = dataReferenceArchive.filter(a => a.num === num)[0].id;
        setIdReferenceSelected(id);
        setModalArchiveCancelReference(true);
        loadReferenceList();
    }
    //Удалит элемент из БД
    function removeReferencerDb(id) {
        setDataReference(dataReference.filter(a => a.id !== id));
        loadReferenceList();
    }
    //Изменет текст элемента справочника
    function changeTextReference(text, num) {
        const new_data = dataReference.map((item) => {
            if (item.num == num) {
                //Если строка меняется из бд, то ставим флаг на изменение строки, иначе добавление
                if (item.status == 0) {
                    return {
                        ...item,
                        name: text, status: 2
                    }
                }
                else {
                    return {
                        ...item,
                        name: text, status: 1
                    }
                }
            }
            else {
                return item
            }
        })
        setDataReference(new_data)
    }

    //Изменение сортировку элемента справочника
    function moveReference({ dragIndex, hoverIndex }) {
        const list_new = immutabilityUpdate(dataReference, {
            $splice: [
                [dragIndex, 1],
                [hoverIndex, 0, dataReference[dragIndex]],
            ],
        })
        const list_new_order = list_new.map((item, index) => {
            return { ...item, order: index, status: item.status === 1 ? 1 : 2 };
        });
        setDataReference(list_new_order)
    }
    /****************************END ЭЛЕМЕНТЫ СПРАВОЧНИКА*************************/

    return (
        <>
            {modalRemoveShow === true && (
                <ParameterModalRemove show={modalRemoveShow} onHide={() => setModalRemoveShow(false)} onHideLabel={() => onHide()} idItem={model.ID} name={model.Name} />
            )}
            {modalArchiveShow === true && (
                <ParameterModalArchive show={modalArchiveShow} onHide={() => setModalArchiveShow(false)} onHideLabel={() => onHide()} idItem={model.ID} name={model.Name} />
            )}
            {modalArchiveCancelShow === true && (
                <ParameterModalArchiveCancel show={modalArchiveCancelShow} onHide={() => setModalArchiveCancelShow(false)} onHideLabel={() => onHide()} idItem={model.ID} name={model.Name} />
            )}
            {modalRemoveReference === true && idReferenceSelected !== null && (
                <ReferenceModalRemove show={modalRemoveReference} onHide={() => setModalRemoveReference(false)} name={dataReference.filter(a => a.id === idReferenceSelected)[0].name} idItem={dataReference.filter(a => a.id === idReferenceSelected)[0].id} update={removeReferencerDb} />
            )}
            {modalArchiveCancelReference === true && idReferenceSelected !== null && (
                <ReferenceModalArchiveCancel show={modalArchiveCancelReference} onHide={() => setModalArchiveCancelReference(false)} name={dataReferenceArchive.filter(a => a.id === idReferenceSelected)[0].name} idItem={dataReferenceArchive.filter(a => a.id === idReferenceSelected)[0].id} update={loadReferenceList} />
            )}

            {stateSize.desktop === true ? (
                <Modal show={show} onHide={onHide} size="lg">
                    <Modal.Body>
                        <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        <div className="row" >
                            <div className="col-md-7" style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: stateSize.windowHeight - 100, overflow: 'auto' }}>
                                <div className="mb-3">
                                    <CardName name={model.Name} onlyRead={false} placeholder='Название параметра...' updateHandler={updateName} hide={hideName} setHide={setHideName} log={logName} loading={loadingName} />
                                    <div className="mt-0 text-uppercase fw-bold opacity-50"><FontAwesomeIcon className="mr-1" icon={ParameterIcon(model.ID_Type)} />  {model.ID_Type === 1 && 'Логический'}{model.ID_Type === 2 && 'Число'}{model.ID_Type === 3 && 'Строка'}{model.ID_Type === 4 && 'Справочник'}{model.ID_Type === 5 && 'Дата'}</div>
                                </div>
                                <div className="mb-3">
                                    <CardDescription text={model.Description} rows={5} placeholder="описание..." updateHandler={updateDescription} loading={loadingDescription} log={logDescription} hide={hideDescription} setHide={setHideDescription} />
                                </div>
                                {model.ID_Type === 4 && (
                                    <>
                                        <div className="d-flex">
                                            <div>
                                                <button className={'param_button mr-5 ' + (tabReference === 1 ? ' active' : '')} onClick={() => setTabReference(1)} /*disabled={loadingTypeDisplayTask}*/>
                                                    Активные
                                                </button>
                                            </div>
                                            <div>
                                                <button className={'param_button ml-5 ' + (tabReference === 0 ? ' active' : '')} onClick={() => setTabReference(0)} /*disabled={loadingTypeDisplayTask}*/>
                                                    Архивные
                                                </button>
                                            </div>
                                        </div>
                                        {tabReference === 1 &&
                                            <>
                                                {dataReference.filter(a => a.status != 3 & a.archive === false).sort((a, b) => a.order - b.order).map((item, index) => (
                                                    <ReferenceBlockItem key={item.num} model={item} index={index} remove={removeReference} changeTextHandler={changeTextReference} moveFile={moveReference} loading={loading} archive={false} />
                                                ))}

                                                <div className="mt-10" style={{ textAlign: "center" }}>
                                                    <SrvButtonLink typeBtn="add"
                                                        onClick={() => addReference()}
                                                        disabled={loadingReference}
                                                    />
                                                </div>
                                                {showSaveReference === true &&
                                                    <div className="mt-10" style={{ textAlign: "center" }}>
                                                        <SrvButton typeBtn="save"
                                                            onClick={() => updateReference()}
                                                            disabled={loadingReference}
                                                        />
                                                    </div>
                                                }
                                            </>
                                        }
                                        {tabReference === 0 &&
                                            <>
                                                {dataReferenceArchive.sort((a, b) => a.order - b.order).map((item, index) => (
                                                    <ReferenceBlockItem key={item.num} model={item} index={index} archiveCancel={archiveCancelReference} changeTextHandler={changeTextReference} moveFile={moveReference} loading={loading} archive={true} />
                                                ))}
                                            </>
                                        }
                                    </>
                                )}
                            </div>
                            <div className="col-md-5" style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: stateSize.windowHeight - 100, overflow: 'auto' }}>
                                <div className="card-block-title">Действия</div>
                                {
                                    model.ID_Status === 1 ? (
                                        <div key={1}>
                                            <div className="mt-5"><ButtonAction typeBtn='remove' onClick={() => setModalRemoveShow(true)} /></div>
                                            <div className="mt-5"><ButtonAction typeBtn='archive' onClick={() => setModalArchiveShow(true)} /></div>
                                        </div>
                                    ) : (
                                        <div key={2}>
                                            <div className="mt-5"><ButtonAction typeBtn='cancel' textBtn='Отмена архивирования' onClick={() => setModalArchiveCancelShow(true)} /></div>
                                        </div>
                                    )
                                }
                                {log != null && (
                                    <div className="form_error text-center">
                                        {log}
                                    </div>
                                )}
                                <div className="card-block-title mt-20">ДОСТУПНЫЕ ОБЪЕКТЫ</div>
                                <div className="mt-15">
                                    <CardObject checkedList={formObject} changeHandler={objectHundler} all={model.All_Object} allHandler={(val) => updateAllObject(val)} />
                                </div>
                                <div className="card-block-title mt-20">ДОСТУПНЫЕ ПРОЕКТЫ</div>
                                <div className="mt-15">
                                    <CardProject selected={formProject} changeHandler={projectHandler} all={model.All_Project} allHandler={(val) => updateAllProject(val)} />
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            ) : (
                <Modal show={show} onHide={onHide} size="lg">
                    <Modal.Body>
                        <div ref={refHeader}>
                            <div style={{ display: 'flex' }}>
                                <CardName name={model.Name} onlyRead={false} placeholder='Название параметра...' updateHandler={updateName} hide={hideName} setHide={setHideName} log={logName} loading={loadingName} />
                                <div className="modal_close" style={{ marginLeft: 'auto' }} onClick={() => onHide()}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                            </div>
                        </div>
                        <div style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: heightBody, overflow: 'auto' }}>
                            <div className="mb-3">
                                <CardDescription text={model.Description} rows={5} placeholder="описание..." updateHandler={updateDescription} loading={loadingDescription} log={logDescription} hide={hideDescription} setHide={setHideDescription} />
                            </div>
                            {/*model.ID_Type === 4 && (
                                <ReferenceBlock list={referenceList} data={referenceDataList} setData={setReferenceDataList} />
                            )*/}

                            <div className="card-block-title mt-20">ДОСТУПНЫЕ ОБЪЕКТЫ</div>
                            <div className="mt-15">
                                <CardObject checkedList={formObject} changeHandler={objectHundler} all={model.All_Object} allHandler={(val) => updateAllObject(val)} />
                            </div>
                            <div className="card-block-title mt-20">ДОСТУПНЫЕ ПРОЕКТЫ</div>
                            <div className="mt-15">
                                <CardProject selected={formProject} changeHandler={projectHandler} all={model.All_Project} allHandler={(val) => updateAllProject(val)} />
                            </div>
                        </div>
                        <div ref={refFooter}>
                            <hr></hr>
                            <div style={{ height: '55px' }}>
                                {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                                <div className="m_btn_block_footer" >
                                    {
                                        model.ID_Status === 1 ? (
                                            <div key={model.ID_Type}>
                                                <ButtonAction typeBtn='remove' onClick={() => setModalRemoveShow(true)} />
                                                <ButtonAction typeBtn='archive' textBtn='Архив' onClick={() => setModalArchiveShow(true)} />
                                            </div>
                                        ) : (
                                            <div key={model.ID_Type}>
                                                <ButtonAction typeBtn='cancel' textBtn='Отмена архивирования' onClick={() => setModalArchiveCancelShow(true)} />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
}
export default ParameterModalUpdate;
